import { z } from 'zod';
import { CardPointeGatewayEnvironment } from '../../../types/ipg/cardpointe/cardpointe-gateway-environment.types';

export const CardPointeGatewayEnvironmentSchema: z.ZodEnum<
    typeof CardPointeGatewayEnvironment
> = z.enum(CardPointeGatewayEnvironment);
